// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gpkB8imjGQ8nGwQ5XMaR{justify-content:space-between;margin-top:4px;padding-top:24px;display:flex}.gpkB8imjGQ8nGwQ5XMaR .bN6gKV3eUQdxLJP3TmbT{gap:8px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"actions": `gpkB8imjGQ8nGwQ5XMaR`,
	"right": `bN6gKV3eUQdxLJP3TmbT`
};
export default ___CSS_LOADER_EXPORT___;
